import { formatGA4EventProps, setDataPath } from '@utils/analytics/utils';
import type { EventProperty, EventType } from '@utils/analytics/types';

export const formatEventProp = (str: string): string => {
  return str.replace(/-/g, '_');
};

export function sendGA4Event(event: EventType, props: EventProperty): void {
  const eventProps: EventProperty = {
    ...formatGA4EventProps(props),
  };

  let dataPathElement = null;
  if (eventProps.item_location) {
    dataPathElement = setDataPath(eventProps.item_location);
  }

  try {
    window.analytics.track(event, {
      ...eventProps,
    });
  } catch (error) {
    if (window?.analytics) {
      console.error(error);
    }
  } finally {
    // log events for stage and local env
    // if (
    //   window.location.hostname.includes('rc-k2') ||
    //   window.location.hostname.includes('localhost')
    // ) {
    //   console.warn(`Call ga4 event "${event}" with args: `, props);
    // }

    dataPathElement && dataPathElement.removeAttribute('data-path');
  }
}
